import React, { useContext } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Menu } from 'semantic-ui-react';
import AppContext, { token_config } from '../../../AppContext';

const AdminSidebar: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { userInfo } = useContext(AppContext);
  const privileges: string[] = userInfo ? userInfo.Privileges.split(',') : [];

  return (
    <>
      <h2>Settings</h2>
      <nav className="nav-sidebar" style={{ padding: 0 }}>
        <Menu compact icon="labeled" vertical>
          {privileges.includes(token_config.MANAGE_USERS) && (
            <Menu.Item
              data-name="Users"
              onClick={() => {
                navigate('/users');
              }}
              active={location.pathname === '/users'}
              style={{
                paddingLeft: '1.3rem'
              }}
            >
              Users
            </Menu.Item>
          )}
          {privileges.includes(token_config.MANAGE_OFFICES) && (
            <Menu.Item
              data-name="Offices"
              onClick={() => {
                navigate('/offices');
              }}
              active={location.pathname === '/offices'}
              style={{
                paddingLeft: '1.3rem'
              }}
            >
              Offices
            </Menu.Item>
          )}
          {privileges.includes(token_config.MANAGE_ADDRESS_BOOKS) && (
            <Menu.Item
              data-name="Address Book"
              onClick={() => {
                navigate('/address_books');
              }}
              active={location.pathname === '/address_books'}
              style={{
                paddingLeft: '1.3rem'
              }}
            >
              Address Book
            </Menu.Item>
          )}
          {privileges.includes(token_config.MANAGE_NEIGHBORHOODS) && (
            <Menu.Item
              data-name="Neighborhoods"
              onClick={() => {
                navigate('/neighborhoods');
              }}
              active={location.pathname === '/neighborhoods'}
              style={{
                paddingLeft: '1.3rem'
              }}
            >
              Neighborhoods
            </Menu.Item>
          )}
          {privileges.includes(token_config.MANAGE_USER_NOTIFICATIONS) && (
            <Menu.Item
              data-name="Notifications"
              onClick={() => {
                navigate('/notifications');
              }}
              active={location.pathname === '/notifications'}
              style={{
                paddingLeft: '1.3rem'
              }}
            >
              Notifications
            </Menu.Item>
          )}
          {privileges.includes(token_config.MANAGE_TAGS) && (
            <Menu.Item
              data-name="Tags"
              onClick={() => {
                navigate('/tags');
              }}
              active={location.pathname === '/tags'}
              style={{
                paddingLeft: '1.3rem'
              }}
            >
              Tags
            </Menu.Item>
          )}
          {userInfo?.IsAllOffices !== "True" && (
            <>
              <Menu.Item
                data-name="Contact Form"
                onClick={() => {
                  navigate('/contact-form');
                }}
                active={location.pathname === '/contact-form'}
                style={{
                  paddingLeft: '1.3rem'
                }}
              >
                Contact Form
              </Menu.Item>
              {privileges.includes(token_config.REPLY_MESSAGE) && (
                <Menu.Item
                  data-name="Reply Message"
                  onClick={() => {
                    navigate('/reply-message');
                  }}
                  active={location.pathname === '/reply-message'}
                  style={{
                    paddingLeft: '1.3rem'
                  }}
                >
                  Reply Message
                </Menu.Item>
              )}
            </>
          )}
          <Menu.Item
            data-name="Email Signature"
            onClick={() => {
              navigate('/email-signature');
            }}
            active={location.pathname === '/email-signature'}
            style={{
              paddingLeft: '1.3rem'
            }}
          >
            Email Signature
          </Menu.Item>
          {userInfo?.AuthenticationTypeId === "2" && (
            <Menu.Item
              data-name="Change Password"
              onClick={() => {
                navigate('/change-password');
              }}
              active={location.pathname === '/change-password'}
              style={{
                paddingLeft: '1.3rem'
              }}
            >
              Change Password
            </Menu.Item>
          )}
          {privileges.includes(token_config.MANAGE_MS_GRAPH) && (
            <Menu.Item
              data-name="MSGraph Subscription"
              onClick={() => {
                navigate('/ms-graph-subscription');
              }}
              active={location.pathname === '/ms-graph-subscription'}
              style={{
                paddingLeft: '1.3rem'
              }}
            >
              MSGraph Subscription
            </Menu.Item>
          )}
        </Menu>
      </nav>
    </>
  );
};

export default AdminSidebar;